module.exports = __webpack_public_path__ + "img/header-memoireRingsExclusive.4491923.jpg";